var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.855 7.839l4.714 4.166-4.714 4.167a.984.984 0 000 1.514c.474.419 1.24.419 1.713 0l5.577-4.929a.984.984 0 000-1.514l-5.577-4.929a1.325 1.325 0 00-1.713 0c-.461.419-.473 1.106 0 1.525z",
    fill: "currentColor"
  })));
}
export default SvgArrowRightInline;